import { useParams } from 'react-router-dom';
import Topic from '../pages/Topic';
import { getTopicConfig } from '../data/topicsWithQuestions';

const TopicRoute = ({ topic: propTopic }) => {
  const params = useParams();
  const key = propTopic || params.topic;
  const config = getTopicConfig(key);

  if (!config) {
    return (
      <div className="max-w-3xl mx-auto p-6">
        <h1 className="text-2xl font-semibold">Topic not found</h1>
        <p className="mt-2 text-gray-600">We couldn't find questions for "{key}".</p>
      </div>
    );
  }
  return (
    <Topic
      title={config.title}
      description={config.description}
      icon={config.icon}
      questions={config.questions}
      topicPath={config.path}
    />
  );
};

export default TopicRoute;
